import { useEffect, useState } from 'react';
import { TOOL_GROUPS, TOOL_COUNT, WIDGET_COUNT, WRITE_COUNT } from '../data/tools';

const ISTANBUL_TIME = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Istanbul' });

/** Own component so the 15s tick re-renders two digits, not the whole board. */
function IstanbulClock() {
    const [time, setTime] = useState(() => ISTANBUL_TIME.format(new Date()));
    useEffect(() => {
        const t = setInterval(() => setTime(ISTANBUL_TIME.format(new Date())), 15_000);
        return () => clearInterval(t);
    }, []);
    return (
        <div className="tkh-clock" aria-live="off">
            Istanbul <b>{time}</b> · IST
        </div>
    );
}

export function DeparturesBoard() {
    let rowIndex = 0;

    return (
        <section id="tools" className="tkh-dep" aria-labelledby="tools-title">
            <div className="tkh-wrap">
                <div className="tkh-dep-head">
                    <div>
                        <p className="tkh-eyebrow">Departures</p>
                        <h2 id="tools-title" className="tkh-h2">
                            {TOOL_COUNT} tools, boarding now.
                        </h2>
                        <p className="tkh-lede">Every tool the assistant can call, grouped the way passengers think. Red rows render an interactive card inside the chat.</p>
                    </div>
                    <IstanbulClock />
                </div>

                <div className="tkh-board" data-reveal>
                    <div className="tkh-board-cols" aria-hidden="true">
                        <span>Tool name</span>
                        <span>Title</span>
                        <span>Remarks</span>
                        <span style={{ textAlign: 'right' }}>Renders</span>
                    </div>

                    {TOOL_GROUPS.map((group) => (
                        <div key={group.code} role="group" aria-label={group.label}>
                            <div className="tkh-sector">
                                <span className="code">{group.code}</span>
                                <h3>{group.label}</h3>
                                <p>{group.blurb}</p>
                            </div>
                            {group.tools.map((tool) => {
                                const i = rowIndex++;
                                return (
                                    <div className="tkh-row" key={tool.name} style={{ '--i': i } as React.CSSProperties}>
                                        <span className="name">{tool.name}</span>
                                        <span className="title">{tool.title}</span>
                                        <span className="remarks">{tool.summary}</span>
                                        <span className="ui">
                                            {tool.write && <span className="tkh-tag tkh-tag-write">writes</span>}
                                            {tool.widget ? <span className="tkh-tag tkh-tag-widget">{tool.widget}</span> : <span className="tkh-tag tkh-tag-data">data</span>}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    ))}

                    <div className="tkh-board-foot">
                        <span>{TOOL_COUNT} tools</span>
                        <span>{WIDGET_COUNT} widgets</span>
                        <span>
                            {TOOL_COUNT - WRITE_COUNT} read-only · {WRITE_COUNT} write
                        </span>
                        <span>Schemas validated with Zod on input and output</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
